import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';

import { ENVIROMENT_SET } from './actions';

export const INITIAL_STATE = Immutable({});

export const actionMap = {
  [ENVIROMENT_SET]: (state, { payload }) => Immutable({ ...state, ...payload }),
};

export default handleActions(actionMap, INITIAL_STATE);
